import { AutoLogout } from "@/setup/auto-logout";
import { TimeService, logbookRoutesMESF } from "@dexteel/mesf-core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { configurationRoutes } from "./routes/configuration.routes";
import { delayRoutes } from "./routes/delay.routes";
import { productionRoutes } from "./routes/production.routes";
import { reportsRoutes } from "./routes/reports.routes";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

// Route sections configuration
const routeSections: {
	routes: { path: string; element: ReactNode; permission?: string }[];
}[] = [
	// Logbook routes from mesf-core
	{ routes: logbookRoutesMESF },
	// Delays routes
	{ routes: delayRoutes },
	// Production routes
	{ routes: productionRoutes },
	// Reports routes
	{ routes: reportsRoutes },
	// Configuration routes
	{ routes: configurationRoutes },
];

const CustomRoutes = () => (
	<AutoLogout>
		<LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
			<Routes>
				<Route
					path={"/"}
					element={<Navigate to={"/delays/manager"} replace />}
				/>
				<Route
					path={"/home"}
					element={<Navigate to={"/delays/manager"} replace />}
				/>

				{routeSections.map((section, index) => {
					return section.routes.map((route) => {
						return (
							<Route
								key={`route-${route.path}`}
								path={route.path}
								element={route.element}
							/>
						);
					});
				})}
			</Routes>
		</LocalizationProvider>
	</AutoLogout>
);

export { CustomRoutes };
